import React from 'react';
import PropTypes from 'prop-types';
import {
  translate as translateHOC,
  TextField,
  Responsive,
  DateField,
  ReferenceManyField,
  Pagination,
  Datagrid,
  ReferenceField,
  FunctionField,
} from 'react-admin';
import { Card, withStyles, IconButton } from '@material-ui/core';
import CommentIcon from '@material-ui/icons/Comment';
import TripDetails from './trip-details';
import utils from '../../shared/utils';
import { getBusinessConf } from '../../core/config';
import TripNotesDetailsDialog from '../shared/TripNotesDetailsDialog';

const styles = {
  container: {
    marginTop: 16,
  },
  tabRoot: {
    flexBasis: '100%',
    minWidth: 10,
  },
};

const fieldsAll = ({ id, handleOpenTripNoteDetailsDialog }) => [
  <ReferenceField
    label="Username"
    source="userId"
    reference="user"
    sortable={false}
    linkType={false}
    allowEmpty
    key="userName"
  >
    <TextField source="userName" id={`Selenium-Trips-textField-withStatus-userName-${id}`} />
  </ReferenceField>,
  <ReferenceField
    label="First name"
    source="userId"
    reference="user"
    sortable={false}
    linkType={false}
    allowEmpty
    key="firstName"
  >
    <TextField source="firstName" id={`Selenium-Trips-textField-withStatus-firstName-${id}`} />
  </ReferenceField>,
  <ReferenceField
    label="Last name"
    source="userId"
    reference="user"
    sortable={false}
    linkType={false}
    allowEmpty
    key="lastName"
  >
    <TextField source="lastName" id={`Selenium-Trips-textField-withStatus-lastName-${id}`} />
  </ReferenceField>,
  <DateField
    source="booking_date"
    key="registrationDate"
    showTime
    id={`Selenium-Trips-textField-withStatus-registrationDate-${id}`}
  />,
  <FunctionField
    key="notesAction"
    label="resources.billing.tripNotes.label"
    render={record => (
      <IconButton
        onClick={event => {
          event.stopPropagation();
          handleOpenTripNoteDetailsDialog(record.tripId);
        }}
      >
        <CommentIcon />
      </IconButton>
    )}
  />,
];

const fieldsWithoutStatus = id => [
  <ReferenceField
    label="Username"
    source="userId"
    reference="user"
    sortable={false}
    linkType={false}
    allowEmpty
    key="userName"
  >
    <TextField source="userName" id={`Selenium-Trips-textField-withoutStatus-userName-${id}`} />
  </ReferenceField>,
  <ReferenceField
    label="First name"
    source="userId"
    reference="user"
    sortable={false}
    linkType={false}
    allowEmpty
    key="firstName"
  >
    <TextField source="firstName" id={`Selenium-Trips-textField-withoutStatus-firstName-${id}`} />
  </ReferenceField>,
  <ReferenceField
    label="Last name"
    source="userId"
    reference="user"
    sortable={false}
    linkType={false}
    allowEmpty
    key="lastName"
  >
    <TextField source="lastName" id={`Selenium-Trips-textField-withoutStatus-lastName-${id}`} />
  </ReferenceField>,
  <DateField
    source="booking_date"
    key="registrationDate"
    showTime
    id={`Selenium-Trips-textField-withoutStatus-registrationDate-${id}`}
  />,
  <TextField
    source="billingStatus"
    key="billingStatus"
    id={`Selenium-Trips-textField-withoutStatus-billingStatus-${id}`}
  />,
];

class BusinessTrips extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      filter: 'ongoing',
      isShowTripDetails: false,
      tripNoteDetailsDialog: {
        open: false,
        tripId: null,
      },
    };
    this.pagination = React.createRef();
  }

  handleChangeFilter = (event, value) => {
    return Promise.resolve(this.handleChangePage(1)).then(() => {
      this.setState({ filter: value });
    });
  };

  handleChangePage = value => {
    this.pagination.current.props.setPage(value);
  };

  handleShowTripDetails = (id, basePath, record) => {
    const { tripId, userId } = record.trip;
    const { filter } = this.state;
    const { config } = getBusinessConf();
    if (config && config.isMapDisplayed !== false) {
      utils.setParameters({
        businessTrip: { tripId, tripDetailStatus: filter === 'ongoing' ? 'Ongoing' : 'Complete', userId },
      });
      this.setState({ isShowTripDetails: true });
    }
  };

  handleHideTripDetails = () => {
    this.setState({ isShowTripDetails: false });
  };

  handleOpenTripNoteDetailsDialog = tripId => {
    this.setState({ tripNoteDetailsDialog: { open: true, tripId } });
  };

  handleCloseTripNoteDetailsDialog = () => {
    this.setState({ tripNoteDetailsDialog: { open: false, tripId: null } });
  };

  render() {
    const { classes, translate, id, ...props } = this.props;
    const record = { id };
    const { filter, isShowTripDetails, tripNoteDetailsDialog } = this.state;
    let fields;
    if (filter === 'ongoing') {
      fields = fieldsAll({ id, handleOpenTripNoteDetailsDialog: this.handleOpenTripNoteDetailsDialog });
    } else {
      fields = fieldsWithoutStatus(id);
    }
    return (
      <>
        <TripDetails isShowDialog={isShowTripDetails} handleCloseDialog={this.handleHideTripDetails} />
        <Card className={classes.container}>
          <Responsive
            medium={
              <ReferenceManyField
                pagination={<Pagination ref={this.pagination} />}
                perPage={10}
                reference="businessTrip"
                record={record}
                target="business"
                {...props}
              >
                <Datagrid rowClick={this.handleShowTripDetails}>{fields}</Datagrid>
              </ReferenceManyField>
            }
          />
        </Card>
        <TripNotesDetailsDialog
          open={tripNoteDetailsDialog.open}
          onClose={this.handleCloseTripNoteDetailsDialog}
          tripId={tripNoteDetailsDialog.tripId}
          context="ONGOING_TRIP"
          readOnly
        />
      </>
    );
  }
}

BusinessTrips.propTypes = {
  id: PropTypes.string,
  translate: PropTypes.func,
  classes: PropTypes.shape({}),
};
export default withStyles(styles)(translateHOC(BusinessTrips));
// For Tests
export const BusinessTripsTest = BusinessTrips;
